/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PayrollViewerControllerGetViewer200ResponseDataChecks } from './payrollViewerControllerGetViewer200ResponseDataChecks';
import { PayrollViewerControllerGetViewer200ResponseDataPeriod } from './payrollViewerControllerGetViewer200ResponseDataPeriod';
import { PayrollViewerControllerGetCatalogs200ResponseDataEmployeesInner } from './payrollViewerControllerGetCatalogs200ResponseDataEmployeesInner';
import { PayrollViewerControllerGetViewer200ResponseDataLinesInner } from './payrollViewerControllerGetViewer200ResponseDataLinesInner';
import { PayrollViewerControllerGetViewer200ResponseDataWarningsInner } from './payrollViewerControllerGetViewer200ResponseDataWarningsInner';


export interface PayrollViewerControllerGetViewer200ResponseData { 
    employee?: PayrollViewerControllerGetCatalogs200ResponseDataEmployeesInner;
    period?: PayrollViewerControllerGetViewer200ResponseDataPeriod;
    currency?: string;
    lines?: Array<PayrollViewerControllerGetViewer200ResponseDataLinesInner>;
    checks?: PayrollViewerControllerGetViewer200ResponseDataChecks;
    warnings?: Array<PayrollViewerControllerGetViewer200ResponseDataWarningsInner>;
}

